import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { RequisitionsConfigFetchResponse, RequisitionsConfigUpdateBody } from './config.types';

@Injectable({ providedIn: 'root' })
export class RequisitionsConfigHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(): Observable<RequisitionsConfigFetchResponse> {
    return this.httpApi.get('/requisitions/settings');
  }

  public update(body: RequisitionsConfigUpdateBody): Observable<RequisitionsConfigFetchResponse> {
    return this.httpApi.patch('/requisitions/settings', {}, body);
  }
}
